import React, {useEffect, useState} from 'react'
import ChangeHistory from 'components/popup/changeHistory/ChangeHistory';
import PropTypes from 'prop-types';
import EmptyOptions from 'components/complex/transferList/options/EmptyOptions';
import Column from 'components/complex/transferList/Column';
import List from 'components/complex/transferList/List';
import FullNamePositionItem from './listItems/FullNamePositionItem';
import Tr from 'translations/Translations';
import getObjectValue from 'libs/getObjectValue';
import Header from 'components/complex/transferList/headers/Header';
import HistoryButton from 'components/button/HistoryButton';
import GridBlock from 'components/GridBlock';
import DatePicker from "components/DatePicker";
import {withStyles} from "@material-ui/core";
import clsx from "clsx";

const style = theme => ({
    helperTextHidden: {
        '&>*.MuiFormHelperText-root': {
            display: "none"
        }
    }
})

function CommissionColumn(
    {
        doLoadHistory,
        formikProps,
        id,
        establishmentId,
        classes,
    }) {
    const [history, setHistory] = useState(false);
    const [commissionHistoryList, setCommissionHistoryList] = useState(null);

    useEffect(() => {
        if (history) {
            doLoadHistory().then((resp => setCommissionHistoryList(resp)));
        } else {
            setCommissionHistoryList(null)
        }
    }, [history, doLoadHistory]);

    let items = getObjectValue(id, formikProps.values, [])

    items = items.sort((a, b) => a.firstName.localeCompare(b.firstName))

    return (
        <Column>
            <GridBlock justify="space-between">
                <Header
                    title={Tr('commission_members')}
                ></Header>
                {
                    !!doLoadHistory && <HistoryButton onClick={() => setHistory(true)}>
                        {Tr('history')}
                    </HistoryButton>
                }
            </GridBlock>
            <EmptyOptions/>
            <List
                grow
                ItemComponent={FullNamePositionItem}
                items={items}
                itemProps={{
                    formikProps,
                    id
                }}
            />
            <GridBlock justify="flex-start">
                <Header
                    title={Tr('commission_establishment')}
                ></Header>
                <DatePicker
                    formikProps={formikProps}
                    id={establishmentId}
                    className={clsx(classes.helperTextHidden)}
                />
            </GridBlock>
            <ChangeHistory historyTab={commissionHistoryList} open={history} onClose={() => setHistory(false)}/>
        </Column>
    )
}

CommissionColumn.propTypes = {
    classes: PropTypes.any,
    items: PropTypes.array,
}

CommissionColumn.defaultProps = {}

export default withStyles(style)(CommissionColumn);